import * as v from 'valibot';
import { structuredContentDocumentSchema } from '../structuredContent/schema';
import { nulltoOptional } from '../utils/validation-utils';

export const faqSchema = v.object({
  question: v.string(),
  answer: nulltoOptional(structuredContentDocumentSchema),
});

export const socialMediaLinkSchema = v.object({
  name: v.string(),
  url: v.string(),
  type: v.picklist(['twitter', 'linkedin', 'facebook', 'email']),
});

export const avatarUrlSchema = v.object({
  url: v.string(),
  size: v.number(),
});

export const authorSchema = v.object({
  affiliation: nulltoOptional(v.string()),
  alumniOf: nulltoOptional(v.string()),
  avatarUrls: v.array(
    v.object({
      url: nulltoOptional(v.string()),
    }),
  ),
  award: nulltoOptional(v.string()),
  description: nulltoOptional(v.string()),
  email: nulltoOptional(v.string()),
  experience: nulltoOptional(v.string()),
  honorificSuffix: nulltoOptional(v.string()),
  id: v.string(),
  jobTitle: nulltoOptional(v.string()),
  link: v.string(),
  name: v.string(),
  roundupBio: nulltoOptional(v.string()),
  socialMediaLinks: nulltoOptional(v.array(socialMediaLinkSchema)),
  tagline: nulltoOptional(v.string()),
  twitter: nulltoOptional(v.string()),
  userPage: v.object({
    bio: nulltoOptional(v.union([structuredContentDocumentSchema, v.string()])),
    experience: nulltoOptional(v.string()),
    jobTitle: nulltoOptional(v.string()),
    link: nulltoOptional(v.string()),
    otherPublications: nulltoOptional(v.array(v.string())),
  }),
});

export const breadcrumbSchema = v.object({
  slug: v.string(),
  page: v.object({
    title: v.string(),
  }),
});

export const hrefLangSchema = v.object({
  locale: v.string(),
  url: v.pipe(v.string(), v.url()),
});

export const featuredMediaSchema = v.object({
  sourceUrl: v.string(),
  height: v.number(),
  width: v.number(),
  croppedImage: nulltoOptional(
    v.object({
      sourceUrl: v.string(),
      height: v.number(),
      width: v.number(),
    }),
  ),
});

export const reviewerSchema = v.pipe(
  nulltoOptional(
    v.array(
      v.object({
        ...v.pick(authorSchema, [
          'alumniOf',
          'avatarUrls',
          'description',
          'experience',
          'honorificSuffix',
          'id',
          'jobTitle',
          'link',
          'name',
          'roundupBio',
          'socialMediaLinks',
          'userPage',
        ]).entries,
        featuredMedia: nulltoOptional(
          v.object({
            id: v.string(),
            croppedImage: v.object({
              sourceUrl: v.string(),
            }),
          }),
        ),
      }),
    ),
  ),
  v.transform(reviewers => reviewers?.[0]),
);

export const twitterSchema = v.object({
  title: v.string(),
  description: v.string(),
});

export const seoSchema = v.object({
  title: v.string(),
  description: v.string(),
  nofollow: v.boolean(),
  noindex: v.boolean(),
  keyword: nulltoOptional(v.string()),
  facebook: nulltoOptional(
    v.object({
      title: v.string(),
      description: v.string(),
    }),
  ),
  twitter: twitterSchema,
});

export const authorsSchema = v.array(authorSchema);
